goog.provide("shadow.js.shim.module$src$svg$devices$server_network_svg");
goog.provide("module$shadow_js_shim_module$src$svg$devices$server_network_svg");
shadow.js.shim.module$src$svg$devices$server_network_svg = shadow.js.nativeProvides["src/svg/devices/server-network.svg"] = shadow$bridge("src/svg/devices/server-network.svg");
module$shadow_js_shim_module$src$svg$devices$server_network_svg.default = shadow.js.shim.module$src$svg$devices$server_network_svg;
